import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";

import download from "../../assets/icons/bxs-file-json.svg";
// import btn3 from "../../assets/icons/analytic.svg";
import btn3 from "../../assets/icons/YML.svg";
import Compactyml from "../../assets/icons/Compact_YML.svg"
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";

import Loader from "../../Components/LoaderAndSpinner/Loader";

const ListOfAssets = () => {
	const [templateStructure, setTemplateStructure] = useState({});
	const [templates, setTemplates] = useState([]);
	const [template, setTemplate] = useState({});
	const [nestedData, setNestedData] = useState([]);
	const [expandedRows, setExpandedRows] = useState({});
	const [prevItem, setPrevItem] = useState({});
	const { lineage_id } = useParams();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const getTemplates = async () => {
			try {
				const data = await fetchWrapper(
					`${process.env.REACT_APP_BASE_API_URL1}/api/v1/templates/type/${lineage_id}`,
					{
						method: "POST",
						body: JSON.stringify({}),
					}
				);

				setTemplates(data.templates || []);
			} catch (error) {
				console.error("Error fetching data:", error.message);
				if (error.message === "Unauthorized") {
					navigate("/auth/login");
				}
			}
		};

		getTemplates();
	}, [navigate, lineage_id]);

	const downloadEquipment = async (item) => {
		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review/download/json`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ template: template, data: item }),
				},
				navigate,
				true // Request the raw response
			);

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `equipment_${item.master_name}.json`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	};

	const downloadEquipmentJSON = async (item) => {
		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${item._id}/download/json`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate,
				true // Request the raw response
			);
			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `equipment_${item.equipment_code}.json`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	};

	const downloadEquipmentReviewPropertiesEquipmentYml = async (equipmentId, name) => {

		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review/properties/equipment/${equipmentId}/download/yml`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate,
				true // Request the raw response
			);
			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `equipment_${name}.yml`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	}


	const downloadEquipmentReviewPropertiesYml = async (item) => {
		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review/properties/download/yml`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ template: template, data: item }),
				},
				navigate,
				true // Request the raw response
			);
			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `${item.document_code}.yaml`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	}

	const downloadEquipmentYml = async (item) => {
		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review/download/yml`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ template: template, data: item }),
				},
				navigate,
				true // Request the raw response
			);

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `equipment_${item.master_name}.yaml`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	};

	const downloadYml = async (item) => {
		setLoading(true);
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${item._id}/download/yml`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({}),
				},
				navigate,
				true // Request the raw response
			);

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = `equipment_${item.equipment_code}.yaml`;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching data:", error.message);
			setLoading(false);
			if (error.message === "Unauthorized") {
				navigate("/auth/login");
				setLoading(false);
			}
		}
	};

	const fetchMasterData = async (templateId, nodeId, parentData = null) => {
		try {
			let selectedTemplate = templates.find(
				(template) => template._id === templateId
			);

			if (!selectedTemplate) {
				console.error("Selected template not found.");
				return;
			}

			setTemplate(selectedTemplate);

			const structure = JSON.parse(selectedTemplate.structure);
			setTemplateStructure(structure);

			if (!nodeId) {
				const firstNode = structure?.[0]?.nodes?.[0]?.id;

				if (!firstNode) {
					console.error("First node ID not found in the template structure.");
					return;
				}
				nodeId = firstNode;
			}

			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/template-master/${templateId}/${nodeId}/review`,
				{
					method: "POST",
					body: JSON.stringify({ data: parentData }),
					headers: {
						"Content-Type": "application/json",
					},
				}
			);

			const data = response.data || [];

			if (parentData) {
				const updateNestedData = (items) => {
					return items.map((item) => {
						if (item._id === parentData._id) {
							return {
								...item,
								nested: data,
							};
						}
						if (item.nested && item.nested.length) {
							return {
								...item,
								nested: updateNestedData(item.nested),
							};
						}
						return item;
					});
				};

				setNestedData((prevData) => updateNestedData(prevData));
			} else {
				setNestedData(data);
			}
		} catch (error) {
			setNestedData()
			console.error("Error fetching master data:", error.message);
		}
	};

	const fetchEquipments = async (item) => {
		try {
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review`,
				{
					method: "POST",
					body: JSON.stringify({ data: item, prevItem: prevItem }),
					headers: {
						"Content-Type": "application/json",
					},
				}
			);

			const data = response.data || [];

			const updateNestedData = (items) => {
				return items.map((childItem) => {
					if (childItem._id === item._id) {
						// Replace existing nested data with new data
						return {
							...childItem,
							nested: data,
						};
					}

					// Recursively update nested items
					if (childItem.nested && childItem.nested.length > 0) {
						return {
							...childItem,
							nested: updateNestedData(childItem.nested),
						};
					}

					return childItem;
				});
			};

			// Update the state with new equipment data, replacing previous data
			setNestedData((prevData) => updateNestedData(prevData));
		} catch (error) {
			console.error("Error fetching equipment data:", error.message);
		}
	};

	const handleRowClick = async (item) => {
		const isExpanded = !!expandedRows[item._id];
		const newExpandedRows = { ...expandedRows };

		if (isExpanded) {
			const collapseChildren = (items) => {
				items.forEach((child) => {
					if (newExpandedRows[child._id]) {
						newExpandedRows[child._id] = false;
						if (child.nested && child.nested.length) {
							collapseChildren(child.nested);
						}
					}
				});
			};

			collapseChildren(item.nested || []);
		}

		newExpandedRows[item._id] = !isExpanded;

		setExpandedRows(newExpandedRows);

		if (!isExpanded) {
			const currentNodeId = item.master_id;
			const nextNode = findNextNode(currentNodeId);
			if (nextNode) {
				if (item.leaf_node) {
					fetchEquipments(item);
				} else {
					setPrevItem(item);
					await fetchMasterData(item.template_id, nextNode.id, item);
				}
			} else {
				fetchEquipments(item);
			}
		}
	};

	const findNextNode = (currentNodeId) => {
		if (!templateStructure || !templateStructure[0]?.nodes) {
			return null;
		}

		const nodes = templateStructure[0].nodes;

		for (let i = 0; i < nodes.length; i++) {
			if (nodes[i].id === currentNodeId) {
				return nodes[i + 1] || null;
			}
		}
		return null;
	};

	const renderNestedData = (items, level = 0) => (
		<>
			{items.map((item) => (
				<React.Fragment key={item._id}>
					<tr>
						{item.document_code ? (
							<td
								onClick={() => handleRowClick(item)}
								className="col"
								style={{ paddingLeft: `${20 * level}px`, cursor: "pointer" }}
							>
								{expandedRows[item._id] ? (
									<span style={{ marginRight: "8px" }}>-</span>
								) : (
									<span style={{ marginRight: "8px" }}>+</span>
								)}
								{item.document_code}
							</td>
						) : (
							<td className="col" style={{ paddingLeft: `${25 * level}px` }}>
								{item.equipment_code + " :: " + item.equipment_name}
							</td>
						)}
						<td className="col">
							{item.master_name ? item.master_name : "Equipment"}
						</td>
						<td className="col-2 text-center">
							{/* Existing buttons for master_name */}
							{item.master_name ? (
								<>
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download YAML file"
										onClick={() => downloadEquipmentReviewPropertiesYml(item)}
									>
										<img style={{ width: "25px" }} src={Compactyml} alt="Download" />
									</button>
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download YAML file"
										onClick={() => downloadEquipmentYml(item)}
									>
										<img style={{ width: "25px" }} src={btn3} alt="Download" />
									</button>
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download JSON file"
										onClick={() => downloadEquipment(item)}
									>
										<img style={{ width: "25px" }} src={download} alt="Download" />
									</button>
								</>
							) : (
								<>
									{/* Existing buttons for equipment */}
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download YAML file"
										onClick={() =>
											downloadEquipmentReviewPropertiesEquipmentYml(item._id, item.equipment_code)
										}
									>
										<img style={{ width: "25px" }} src={Compactyml} alt="Download" />
									</button>
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download YAML file"
										onClick={() => downloadYml(item)}
									>
										<img style={{ width: "25px" }} src={btn3} alt="Download" />
									</button>
									<button
										style={{ border: "none", backgroundColor: "transparent" }}
										className="align-content-center me-3 mt-1"
										title="Download JSON file"
										onClick={() => downloadEquipmentJSON(item)}
									>
										<img style={{ width: "25px" }} src={download} alt="Download" />
									</button>
								</>
							)}
							{/* :white_check_mark: New DQ Button */}
							<button
								style={{ border: "1px solid #ccc", backgroundColor: "#F8F9FA", padding: "5px 10px", borderRadius: "5px" }}
								className="align-content-center me-3 mt-1"
								title="DQ Action"
								onClick={() => handleDQClick(item)}
							>
								DQ
							</button>
						</td>
					</tr>
					{expandedRows[item._id] &&
						item.nested &&
						item.nested.length > 0 &&
						renderNestedData(item.nested, level + 1)}
				</React.Fragment>
			))}
		</>
	);
	const handleDQClick = async (item) => {
		try {
			console.log("DQ clicked for:", item);
			console.log("Templates:", templates);
			const template = templates.find(t => t._id === item.template_id);
			const templateName = template ? template.template_name : '';
			console.log("Template Name:", templateName);
			console.log("Master Name:", item.master_name);
			
			// Get the DQ URL from the backend
			const response = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/generate-dq-token`,
				{ method: "POST", body: JSON.stringify({}) },
				navigate
			);
			
			if (response?.redirectUrl) {
				// Extract base URL from redirectUrl (remove /dq/?token=...)
				const baseUrl = response.redirectUrl.split('/dq/')[0];
				
				// Build query params
				const params = new URLSearchParams({
					id: item._id || '',
					data: item.document_code || '',
					equipment_code: item.equipment_code || '',
					equipment_name: item.equipment_name || '',
					master_name: item.master_name || '',
					template_name: templateName
				});
				
				const dqUrl = `${baseUrl}/dq/?${params.toString()}`;
				console.log("Opening URL:", dqUrl);
				window.open(dqUrl, '_blank');
			} else {
				console.error("Failed to get DQ URL from backend");
			}
		} catch (error) {
			console.error("Error generating DQ redirect URL:", error);
		}
	};
	return (
		<>
			{loading ? (
				<Loader />
			) : (
				<div className="">
					<div className="container">
						<div className="pt-3 pb-0 d-flex justify-content-between">
							<div className="">
								<h5>List of Assets</h5>
								<nav className="breadcrumb-nav" aria-label="breadcrumb">
									<ol className="breadcrumb">
										<li className="breadcrumb-item">
											<Link to="#" style={{ textDecoration: "none" }}>
												Review
											</Link>
										</li>
										<li className="breadcrumb-item active" aria-current="page">
											List of Assets
										</li>
									</ol>
								</nav>
							</div>
							<div className="d-flex gap-3">
								<div className="dropdown">
									<select
										id="templates"
										style={{ padding: "10px", width: "250px" }}
										className="select-unit textarea"
										onChange={(e) => fetchMasterData(e.target.value, null)}
									>
										<option value="">Select Template</option>
										{templates.map((template) => (
											<option key={template._id} value={template._id}>
												{template.template_name}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className="">
							<div className="table-responsive">
								<table className="table align-middle table-text">
									<thead className="table-head align-middle">
										<tr>
											<th className="col text-uppercase">Data</th>
											<th className="col text-uppercase">Master</th>
											<th className="col-2 text-center">ACTION</th>
										</tr>
									</thead>
									{/* <tbody>{renderNestedData(nestedData)}</tbody> */}

									<tbody>
										{!Array.isArray(nestedData) || nestedData.length === 0 ? (
											<tr>
												<td colSpan="100%" className="text-center">No data available</td>
											</tr>
										) : (
											renderNestedData(nestedData)
										)}
									</tbody>

								</table>
							</div>
						</div>
					</div>
					<ToastContainer
						position="top-right"
						autoClose={3000}
						hideProgressBar={false}
					/>
				</div>
			)}
		</>
	);
};

export default ListOfAssets;
